"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiplePropertyUserFields$ = exports.MultiplePropertyUserFields$outboundSchema = exports.MultiplePropertyUserFields$inboundSchema = exports.MultiplePropertyUserFields = void 0;
const z = __importStar(require("zod"));
exports.MultiplePropertyUserFields = {
    Address: "address",
    AirportNoise: "airport_noise",
    ConstructionAgeBand: "construction_age_band",
    ConstructionMaterials: "construction_materials",
    CouncilTax: "council_tax",
    DistanceFromPoint: "distance_from_point",
    Education: "education",
    EnergyPerformance: "energy_performance",
    EstimatedRentalValues: "estimated_rental_values",
    EstimatedValue: "estimated_value",
    EstimatedValueRounded: "estimated_value_rounded",
    EstimatedValues: "estimated_values",
    FloodRisk: "flood_risk",
    Hmo: "hmo",
    Identities: "identities",
    InternalAreaSquareMetres: "internal_area_square_metres",
    IsOnTheMarket: "is_on_the_market",
    IsBungalow: "is_bungalow",
    LatestTransactionDate: "latest_transaction_date",
    ListedBuildingsOnPlot: "listed_buildings_on_plot",
    Localities: "localities",
    Location: "location",
    NumberOfBedrooms: "number_of_bedrooms",
    NumberOfBathrooms: "number_of_bathrooms",
    Occupancy: "occupancy",
    OutdoorSpace: "outdoor_space",
    Ownership: "ownership",
    Plot: "plot",
    PropensityToSellScore: "propensity_to_sell_score",
    PropensityToLetScore: "propensity_to_let_score",
    PropertyType: "property_type",
    StreetGroupPropertyId: "street_group_property_id",
    Tenure: "tenure",
    TitleDeeds: "title_deeds",
    Transactions: "transactions",
    Transport: "transport",
    Utilities: "utilities",
    YearBuilt: "year_built",
    RestrictiveCovenants: "restrictive_covenants",
    CoastalErosion: "coastal_erosion",
    RightOfWay: "right_of_way",
    RadonRiskLevel: "radon_risk_level",
    NearbyScheduledMonuments: "nearby_scheduled_monuments",
};
/** @internal */
exports.MultiplePropertyUserFields$inboundSchema = z.nativeEnum(exports.MultiplePropertyUserFields);
/** @internal */
exports.MultiplePropertyUserFields$outboundSchema = exports.MultiplePropertyUserFields$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MultiplePropertyUserFields$;
(function (MultiplePropertyUserFields$) {
    /** @deprecated use `MultiplePropertyUserFields$inboundSchema` instead. */
    MultiplePropertyUserFields$.inboundSchema = exports.MultiplePropertyUserFields$inboundSchema;
    /** @deprecated use `MultiplePropertyUserFields$outboundSchema` instead. */
    MultiplePropertyUserFields$.outboundSchema = exports.MultiplePropertyUserFields$outboundSchema;
})(MultiplePropertyUserFields$ || (exports.MultiplePropertyUserFields$ = MultiplePropertyUserFields$ = {}));
//# sourceMappingURL=multiplepropertyuserfields.js.map